// extracted by mini-css-extract-plugin
export default {"CallsCheckLists":"callsCheckLists_CallsCheckLists__584IP","chekListAppraised":"callsCheckLists_chekListAppraised__n6Wjr"};